import { ColorBlockTitle } from './ColorBlockTitle';
export default ColorBlockTitle;
